import script from "./LoadAnnotationGroupsMixin.vue?vue&type=script&lang=js"
export * from "./LoadAnnotationGroupsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__